<template>
    <div class="investMoney acccont">
        <div class="acctit">
            <div @click="returnpage" class="returnbtn" v-if="isApp"><i class="el-icon-arrow-left"></i></div>
            {{$t('account.recharge')}}
        </div>
        <div class="czbox">
            <div class="texac gzimgbox">
                <div class="accctit">
                    {{$t('account.recharge_account')}}
                </div>
                <div class="flexbox borderr fle-sa">
                    <div :class="['item item5 bgb',type==1? 'active' :'']">
                        <div class="tip" @click="chooseType(1)">USDT-TRC20</div>
                    </div>
                    <div :class="['item item5 bgb',type==2? 'active' :'']">
                        <div class="tip" @click="chooseType(2)">USDT-ERC20</div>
                    </div>
                </div>
                <div v-if="type==1"  v-html="info.recharge_account" style="text-align: center"></div>
                <div v-if="type==2"  v-html="info.recharge_account2" style="text-align: center"></div>
                <div v-if="type==1" class="imgmimi">
                    USDT-TRC20: <span class="colory wordbreak">{{trc20}}</span> <span class="bgb" @click="copy(1)">{{$t('account.copy')}}</span>
                </div>
                <div v-if="type==2" class="imgmimi">
                    USDT-ERC20: <span class="colory wordbreak">{{erc20}}</span> <span class="bgb" @click="copy(2)">{{$t('account.copy')}}</span>
                </div>
            </div>
            <div class="texac">
                <div class="formbox">
                    <div class="accctit">
                        {{$t('account.recharge_filling')}}
                    </div>
                    <div class="tiplin colorr2">{{$t('account.recharge_image_tip')}}</div>
                    <el-form :model="form" ref="form" label-width="140px">
                        <el-form-item :label="$t('account.upload_voucher')" class="texal">
                            <el-upload
                                    :action="uploadURL"
                                    list-type="picture-card"
                                    :headers="uploadHeaders"
                                    :limit="1"
                                    :on-exceed="masterFileMax"
                                    :on-change="handleEditChange"
                                    :on-remove="handleRemove"
                                    :on-success="handleSuccess"
                                    :class="{disabled: uploadDisabled}"
                            >
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item :label="$t('account.recharge_amount')">
                            <el-input prefix-icon="el-icon-money" v-model="form.amount"
                                      :placeholder="$t('account.input_recharge_amount')" autocomplete="off"
                                      type="number"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('account.trader_password')">
                            <el-input prefix-icon="el-icon-key" type="password" v-model="form.pay_password"
                                      :placeholder="$t('account.input_trader_password')" autocomplete="off"></el-input>
                        </el-form-item>
                        <div class="btnn bgb texac" @click="submitForm()">{{$t('account.confirm')}}</div>
                    </el-form>
                </div>
            </div>
            <div class="texac examplebox">
                <div class="accctit">
                    {{$t('account.recharge_example')}}
                </div>
                <div class="examplelistbox flexbox fle-sa fle-wrap" v-html="info.recharge_example">
                </div>
            </div>
            <div class="texac czls">
                <div class="accctit">
                    {{$t('account.recharge_record')}}
                </div>
                <div class="sylistbox">
                    <div class="tablet flexbox">
                        <div>{{$t('account.recharge_amount2')}}</div>
                        <div>{{$t('account.recharge_status')}}</div>
                        <div>{{$t('account.recharge_date')}}</div>
                    </div>
                    <div class="srollbox">
                        <div class="tablet itemvue flexbox" v-for="(item, index) in lists" :key="index">
                            <div>{{item.amount}}</div>
                            <div>{{item.status_text}}</div>
                            <div>{{item.createtime2}}</div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import {
        getToken
    } from '@/utils/auth'
    import {getUploadURL, getList, addOrder} from '@/api/recharge'

    export default {
        name: 'investMoney',
        data() {
            return {
                type: 1,
                uploadURL: '',
                uploadHeaders: {},
                uploadDisabled: false,
                form: {
                    image: '',
                    amount: '',
                    pay_password: ''
                },
                classOption: {
                    step: 0.5
                },
                lists: [],
                info: {
                    recharge_account: '',
                    recharge_account2: '',
                    recharge_example: '',
                },
                trc20: '',
                erc20: '',
            }
        },
        computed: {
            isApp() {
                return document.documentElement.clientWidth < 800 ? true : false
            },
            routeName() {
                console.log(this.$route.path)
                return this.$route.path
            }
        },
        created() {
            this.uploadURL = getUploadURL()
            let token = getToken()
            if (token) {
                this.uploadHeaders = {token: token}
            }

            this.getData()
        },
        methods: {
            returnpage() {
                this.$router.go(-1)
            },
            chooseType(type) {
                this.type = type;
            },
            copy(type){
                let address = "";
                if(type == 1){  // TRC20
                    address = this.trc20
                }else if(type == 2){    // ERC20
                    address = this.erc20
                }
                // 创建输入框元素
                let oInput = document.createElement('input');
                // 将想要复制的值
                oInput.value = address;
                // 页面底部追加输入框
                document.body.appendChild(oInput);
                // 选中输入框
                oInput.select();
                // 执行浏览器复制命令
                document.execCommand('Copy');
                // 弹出复制成功信息
                this.$message.success(this.$t('account.copy_success'));
                // 复制后移除输入框
                oInput.remove()
            },
            getData() {
                console.log(this.uploadURL);
                getList().then(res => {
                    console.log(res)
                    const data = res.data
                    this.lists = data.lists
                    this.info = data.info
                    this.trc20 = data.trc20
                    this.erc20 = data.erc20
                    let recharge_account = this.info.recharge_account;

                    recharge_account = recharge_account.replace(/height="\d+"/gi, '');
                    recharge_account = recharge_account.replace(/width="\d+"/gi, '');
                    recharge_account = recharge_account.replace(/style\s*?=\s*?([‘"])[\s\S]*?\1/ig, '');
                    recharge_account = recharge_account.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match, reSrc) {
                        //reSrc,返回每个匹配的字符串
                        let newImg = '<a href="' + reSrc + '" target="_blank"><img src="' + reSrc + '" alt="" style="width:80%;" /></a>';
                        return newImg;
                    });
                    this.info.recharge_account = recharge_account;


                    let recharge_account2 = this.info.recharge_account2;

                    recharge_account2 = recharge_account2.replace(/height="\d+"/gi, '');
                    recharge_account2 = recharge_account2.replace(/width="\d+"/gi, '');
                    recharge_account2 = recharge_account2.replace(/style\s*?=\s*?([‘"])[\s\S]*?\1/ig, '');
                    recharge_account2 = recharge_account2.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match, reSrc) {
                        //reSrc,返回每个匹配的字符串
                        let newImg = '<a href="' + reSrc + '" target="_blank"><img src="' + reSrc + '" alt="" style="width:80%;" /></a>';
                        return newImg;
                    });
                    this.info.recharge_account2 = recharge_account2;

                    let recharge_example = this.info.recharge_example;
                    recharge_example = recharge_example.replace(/height="\d+"/gi, '');
                    recharge_example = recharge_example.replace(/width="\d+"/gi, '');
                    recharge_example = recharge_example.replace(/style\s*?=\s*?([‘"])[\s\S]*?\1/ig, '');
                    recharge_example = recharge_example.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match, reSrc) {
                        //reSrc,返回每个匹配的字符串
                        let newImg = '<a href="' + reSrc + '" target="_blank"><img src="' + reSrc + '" alt="" style="width:100%;" /></a>';
                        return newImg;
                    });
                    this.info.recharge_example = recharge_example;

                }).catch(_ => {

                })
            },
            submitForm() {
                if (this.form.image == '') {
                    this.$message.error(this.$t('account.select_upload_voucher'))
                    return false
                }
                if (this.form.amount.length == 0) {
                    this.$message.error(this.$t('account.input_recharge_amount'))
                    return false
                }
                if (Number(this.form.amount) <= 0) {
                    this.$message.error(this.$t('account.input_right_recharge_amount'))
                    return false
                }
                if (this.form.pay_password == "") {
                    this.$message.error(this.$t('account.input_your_trader_password'))
                    return false
                }
                this.submit()
            },
            submit() {

                let params = {...this.form}
                let that = this
                addOrder(params).then(res => {
                    if (res.code == 1) {
                        this.$message.success(res.msg)
                        setTimeout(function () {
                            that.$router.go(0)
                        }, 1000);
                    } else {
                        this.$message.error(res.msg)
                    }

                }).catch(_ => {

                })

            },
            masterFileMax(files, fileList) {
                this.$message.warning(`One file allowed。`)
            },
            handleEditChange(file, fileList) {
                this.uploadDisabled = fileList.length >= 1
            },

            handleRemove(file, fileList) {
                this.uploadDisabled = fileList.length >= 1
                this.form.image = ''
            },
            handleSuccess(res) {
                this.form.image = res.data.data.src
                console.log(res.data.data.src)

            },
        }
    }
</script>
<style lang="scss" scoped>
    .disabled {
        ::v-deep .el-upload--picture-card {
            display: none;
        }
    }
    .imgmimi{
      img{
        width: 20px;
      }
    }

    .investMoney {
        font-size: 18px;

        .accctit {
            font-size: 24px;
            font-weight: bold;
            line-height: 60px;
        }

        .tiplin {
            line-height: 40px;
        }

        .marr {
            text-align: center;
            line-height: 26px;

            img {
                width: 200px;
                height: 200px;
                margin-right: 30px;
            }
        }

        .gzimgbox {
            width: 60%;
            margin: 20px auto;
        }

        .examplelistbox {
            img {
                width: 300px;
                height: auto;
                margin: 10px;
            }
        }
        .wordbreak{
          word-wrap: break-word;
          word-break: normal;
        }

        .sylistbox {
            .tablet {
                width: 100%;
                background: #3a3a3a;

                & > div {
                    width: 33.2%;
                    height: 50px;
                    border: 1px solid #5c5c5c;
                    line-height: 50px;
                    font-size: 18px;

                }

                &.itemvue {
                    border: 0px;
                    color: #fff;
                    background: #3a3a3a;

                    & > div {
                        border: 0px;
                        color: #fff;
                    }

                }
            }

            .srollbox {
                height: 400px;

                overflow: hidden;
            }
        }

        .examplebox {
            padding: 30px 0px;
        }

        .formbox {
            width: 60%;
            margin: 30px auto;
            padding: 30px;
            border-radius: 20px;
            border: 1px solid rgb(85, 85, 85);

            .bgb {
                margin: 40px 0px 20px 0px;
                padding: 14px 30px;
                background: #1750cc;
                color: #fff;
                font-size: 20px;
            }
        }
    }

    .item5{
      width: 50%;
      &.bgb {
        &:nth-child(1){
          border-bottom-left-radius: 4px;
          border-top-left-radius: 4px;
        }
        &:nth-child(2){
          border-bottom-right-radius: 4px;
          border-top-right-radius: 4px;
        }
                margin: 10px 0px 10px 0px;
                padding: 8px 20px;
                background: #fff;
                color: #1750cc;
                font-size: 14px;
                border: 1px solid #fff;
                cursor: pointer;
                border-radius: 0px;
                text-align: center;
                &.active{
                  border: 1px solid #e0c447;
                  background: #1750cc;
                  color: #fff;
                  font-size: 20px;
                  font-weight: bold;
                }
            }

    }
    .bgb {
                margin: 10px 0px 10px 0px;
                padding: 4px 10px;
                background: #1750cc;
                color: #fff;
                font-size: 16px;
                border-radius: 4px;
                cursor: pointer;
            }

</style>
